import { render, staticRenderFns } from "./disabledLanguageResult.vue?vue&type=template&id=3a4e60a2&scoped=true&"
import script from "./disabledLanguageResult.vue?vue&type=script&lang=js&"
export * from "./disabledLanguageResult.vue?vue&type=script&lang=js&"
import style0 from "./disabledLanguageResult.vue?vue&type=style&index=0&id=3a4e60a2&prod&lang=scss&scoped=true&"
import style1 from "./disabledLanguageResult.vue?vue&type=style&index=1&id=3a4e60a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e60a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VExpansionPanel,VExpansionPanelHeader,VIcon,VTooltip})
